/* eslint-disable dot-notation */
import { Route } from 'vue-router'
import { Context } from '@nuxt/types'
import { env } from '@ustra/core'
import { isBrowser } from '@ustra/core/src/utils/web-utils'
import CookieStorage from '@ustra/core/src/utils/storage/cookie-storage'
import * as cryptoUtils from '@ustra/core/src/utils/client/crypto-utils'

/**
 * 현재 route의 일치하는 Component 조회
 * @param route
 */
export const getMatchedComponents = (route: Route) => {
  return [].concat.apply(
    [],
    route.matched.map(m => {
      return Object.keys(m.components).map(key => {
        return m.components[key]
      })
    }),
  )
}

/**
 * route 옵션을 조회한다.
 * @param route
 */
export function getRouteOption(route: Route) {
  let option = null
  route.matched.forEach(value => {
    if (process.client) {
      Object.values(value.components).some((component: any) => {
        if (component.options) {
          option = component.options
        }
      })
    } else {
      Object.values(value.components).some(component => {
        if (component['_Ctor']) {
          Object.values(component['_Ctor']).some(ctor => {
            if (ctor['options']) {
              option = ctor['options']
            }
          })
        }
      })
    }
  })

  return option
}

/**
 * getStaticServerData 어플리케이션의 서버 데이터를 조회한다.
 * @param dataId 조회할 layer id
 */
export const getStaticServerData = (dataId = '__spa') => {
  const serverDataStr = document.querySelector(`#${dataId}`)?.textContent

  if (serverDataStr) {
    return { serverData: JSON.parse(serverDataStr) }
  }

  return { serverData: {} }
}

/**
 * ustra plugin 조회
 */
export const $ustra = () => {
  return contextHolder.get()?.$ustra
}

const getRequestContext = () => {
  const requestContext = require('@ustra/core/src/server/request-context').default
  return requestContext
}

/**
 * context holder
 */
export const contextHolder = {
  get: (): Context => {
    if (!isBrowser()) {
      return getRequestContext().get('context') as Context
    } else {
      return window.$nuxt.context as Context
    }
  },
  set: (context: Context) => {
    if (isBrowser()) {
      context.isClient = true
    }

    if (!isBrowser()) {
      getRequestContext().set('context', context)
    } else {
      // eslint-disable-next-line no-lonely-if
      if (!window.$nuxt) {
        // @ts-ignore
        window.$nuxt = { context }
      } else {
        window.$nuxt.context = context
      }
    }
  },
}

/**
 * named context holder
 */
export const namedContextHolder = {
  get: (name: string) => {
    if (!isBrowser()) {
      return getRequestContext().get(name)
    }
  },
  set: (name: string, value: any) => {
    if (!isBrowser()) {
      getRequestContext().set(name, value)
    }
  },
}

/**
 * nuxt config 객체를 조회한다.
 */
export const getNuxtConfig = (): any => {
  const context = contextHolder.get()
  if (context) {
    // @ts-ignore
    return context.$config
  }

  return null
}

/**
 * 현재 프로파일 조회
 * @type {env.Profile}
 */
export const getCurrentProfile = (configEnv?: string): env.Profile => {
  const cookieStorage = new CookieStorage({
    keyConverter: null,
    valueConverter: null,
  })
  const context = contextHolder.get()

  try {
    const encProfile = context ? cookieStorage.getItem('c', context.req, context.res) : cookieStorage.getItem('c')

    if (encProfile) {
      const decProfile = cryptoUtils.decryptAes256(cryptoUtils.decryptAes256(encProfile, process.env.SERVER_PROP_ENC_KEY), process.env.SERVER_PROP_ENC_KEY)

      // @ts-ignore
      return env.utils.originCurrentProfile ? env.utils.originCurrentProfile(decProfile, env.Profile.PRODUCTION) : env.utils.currentProfile(decProfile, env.Profile.PRODUCTION)
    } else {
      // @ts-ignore
      return env.utils.originCurrentProfile ? env.utils.originCurrentProfile(configEnv) : env.utils.currentProfile(configEnv)
    }
  } catch (e) {
    // @ts-ignore
    return env.utils.originCurrentProfile ? env.utils.originCurrentProfile(configEnv) : env.utils.currentProfile(configEnv)
  }
}
